enum CountryEntryPoints {
  getSelect = '/api/select/country',
}

export default CountryEntryPoints;
